import { render, staticRenderFns } from "./company-legal-info.html?vue&type=template&id=6dc14b16&scoped=true&external"
import script from "./company-legal-info.js?vue&type=script&lang=js&external"
export * from "./company-legal-info.js?vue&type=script&lang=js&external"
import style0 from "./company-legal-info.scss?vue&type=style&index=0&id=6dc14b16&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc14b16",
  null
  
)

export default component.exports